import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginIdInputSection from '../../components/auth/LoginIdInputSection';
import LoginPasswordInputSection from '../../components/auth/LoginPasswordInputSection';
import {
    SignupFormContainer,
    SubmitButton,
    FormTitle,
    Message,
    SignupSection,
    SignupText,
    SignupButton,
} from '../../components/auth/style';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config/URL/URL';
import PageTransition from '../../components/atoms/PageTransition';
import AnimatedButton from '../../components/atoms/AnimatedButton';

const Login = () => {
    const location = useLocation();
    const prevPath = location.state?.from;

    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { isLoggedIn, loggedInUser, login, logout } = useAuth();

    const navigate = useNavigate();

    const navigatePrevPage = (prevPage, currentPage) => {
        if(currentPage === prevPage || !prevPage) {
            navigate("/");
        } else {
            navigate(prevPath)
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');

        if (!userId || !password) {
            setErrorMessage('아이디와 비밀번호를 모두 입력해주세요.');
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/user/login`, {
                // const response = await axios.post('http://localhost:8080/user/login', {
                userId,
                password,
            });

            if (response.status === 200) {
                // alert('로그인 성공');
                login(userId);
                navigate(prevPath);
            }
        } catch (error) {
            console.error('로그인 에러:', error);
            if (error.response && error.response.data) {
                setErrorMessage(error.response.data);
            } else {
                setErrorMessage('로그인에 실패했습니다(서버 오류 또는 네트워크 문제).');
            }
        }
    };

    if (isLoggedIn) {
        navigatePrevPage(prevPath, location.pathname);
    }



    return (
        <PageTransition variant="fade">
            <SignupFormContainer onSubmit={handleSubmit}>
                <FormTitle>로그인</FormTitle>

                <LoginIdInputSection userId={userId} setUserId={setUserId} />

                <LoginPasswordInputSection password={password} setPassword={setPassword} />

                {errorMessage && <Message isError={true}>{errorMessage}</Message>}

                <SubmitButton type="submit">로그인</SubmitButton>

                <SignupSection>
                    <SignupText>아직 회원이 아니신가요?</SignupText>
                    <AnimatedButton
                        type="button"
                        onClick={() => alert('회원가입 준비중입니다.')}
                        // onClick={() => navigate('/user/signup')}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#002755',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontSize: '14px',
                            padding: '5px 10px',
                        }}
                    >
                        회원가입
                    </AnimatedButton>
                </SignupSection>
            </SignupFormContainer>
        </PageTransition>
    );
};

export default Login;
